import api from './api';

export interface StatusTranslationItem {
  id?: number;
  nation?: string;
  english: string;
  chinese: string;
  created_at?: string;
  updated_at?: string;
}

class StatusTranslationService {
  async list(params?: { nation?: string; search?: string; page?: number; per_page?: number }) {
    const res = await api.get('/status-translations', { params });
    return res.data as { success: boolean; data: { data: StatusTranslationItem[]; [k: string]: any } };
  }

  async create(item: StatusTranslationItem) {
    const res = await api.post('/status-translations', item);
    return res.data as { success: boolean; data?: StatusTranslationItem; message?: string };
  }

  async update(id: number, item: StatusTranslationItem) {
    const res = await api.put(`/status-translations/${id}`, item);
    return res.data as { success: boolean; data?: StatusTranslationItem; message?: string };
  }

  async delete(id: number) {
    const res = await api.delete(`/status-translations/${id}`);
    return res.data as { success: boolean; message?: string };
  }

  async batchDelete(ids: number[]): Promise<{ success: boolean; message: string; deleted_count?: number }> {
    const res = await api.post('/status-translations/batch-delete', { ids });
    return res.data;
  }

  async exportAll(): Promise<Blob> {
    const res = await api.get('/status-translations-export', {
      responseType: 'blob',
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });
    return res.data;
  }

  async importAll(file: File): Promise<{ success: boolean; data?: any; message?: string }> {
    const formData = new FormData();
    formData.append('file', file);
    const res = await api.post('/status-translations-import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data;
  }
}

const statusTranslationService = new StatusTranslationService();
export default statusTranslationService;
